<template>
  <el-card class="h-full" :body-style="{ padding: '20px', height: '100%' }">
    <el-page-header content="数据预览" @back="back"> </el-page-header>
    <el-row class="flex mt-20px" :gutter="10">
      <el-form label-width="80px" :model="search">
        <el-col :span="6">
          <el-form-item label="模型编码">
            <el-input size="small" v-model="search.dataModelCode" disabled class="mr-10px" />
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="模型名称">
            <el-input size="small" v-model="search.dataModelName" disabled class="mr-10px" />
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="维度">
            <el-select
              size="small"
              v-model="search.code"
              class="mr-10px"
              placeholder="请选择维度"
              clearable
              filterable
            >
              <el-option
                v-for="(item, index) in dimensionList"
                :key="index"
                :label="item.name"
                :value="item.code"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="5">
          <el-form-item label="维度值">
            <el-input
              size="small"
              v-model="search.keyword"
              class="mr-10px"
              placeholder="请输入维度值"
              clearable
            />
          </el-form-item>
        </el-col>
        <el-col :span="1">
          <el-button type="primary" @click="getTableData()">{{ $t('search') }}</el-button>
        </el-col>
      </el-form>
    </el-row>
    <el-table v-loading="loading" :data="tableData" ref="table" border height="calc(100% - 160px)">
      <el-table-column
        v-for="(val, index) in tableHeader"
        :prop="val.code"
        :label="val.name"
        :key="index"
        show-overflow-tooltip
      >
      </el-table-column>
    </el-table>
    <el-pagination
      class="mt-20px"
      background
      @current-change="handleCurrentChange"
      @size-change="handleSizeChange"
      :current-page.sync="page.pageNo"
      :page-size="page.pageSize"
      :page-sizes="$pageSizeAll"
      layout="->, total, sizes, prev, pager, next, jumper"
      :total="page.total"
    ></el-pagination>
  </el-card>
</template>

<script>
import DataModelService from '@/services/DataModelService'

export default {
  name: 'DataPreview',
  data() {
    return {
      search: {
        dataModelCode: '',
        dataModelName: '',
        code: '',
        keyword: '',
        dataModelId: '',
      },
      tableData: [],
      tableHeader: [],
      loading: false,
      page: {
        pageNo: 1,
        pageSize: 15,
        total: 0,
      },
      dimensionList: [],
    }
  },
  methods: {
    back() {
      this.$router.go(-1)
    },
    async getTableData() {
      if (!this.search.dataModelId) return
      this.loading = true
      const res = await DataModelService.dataPreview({
        maxResultCount: this.page.pageSize,
        skipCount: (this.page.pageNo - 1) * this.page.pageSize,
        sorting: '',
        dataModelId: this.search.dataModelId,
        keyword: this.search.keyword,
        code: this.search.code,
      })
      this.loading = false
      if (res && res.code === 0 && res.data) {
        this.tableData = res.data
        this.page.total = res.totalCount
      }
    },
    // 获取数据预览表头
    async dataPreviewHeader() {
      if (!this.search.dataModelId) return
      const res = await DataModelService.dataPreviewHeader(this.search.dataModelId)
      if (res && res.code === 0 && res.data) {
        this.tableHeader = res.data
      }
    },
    // 获取维度列表
    async getDimension() {
      if (!this.search.dataModelId) return
      const res = await DataModelService.getModelDetail(this.search.dataModelId)
      if (res && res.code === 0 && res.data) {
        this.dimensionList = res.data.dimensionList
      }
    },
    handleCurrentChange(num) {
      this.page.pageNo = num
      this.getTableData()
    },
    handleSizeChange(size) {
      this.page.pageSize = size
      this.getTableData()
    },
  },
  created() {
    this.search.dataModelId = this.$route.query.id
    this.search.dataModelName = this.$route.query.name
    this.search.dataModelCode = this.$route.query.code
    this.getDimension()
    this.dataPreviewHeader()
    this.getTableData()
  },
}
</script>
